module.exports = __webpack_public_path__ + "img/it.1b59b588.svg";